import { ICsatSettings, IEnabledProjectSetting, IModeProject } from './client';
import {
  ModeProjectServer,
  EnabledProjectSettingServer,
  UserVars,
  CsatSettingsServer
} from './server';

export const normalizeModeProject = (raw: ModeProjectServer): IModeProject => ({
  enabled: raw.enabled,
  in: raw.in
});

export const normalizeEnabledProjectSetting = (
  raw: EnabledProjectSettingServer
): IEnabledProjectSetting => ({
  enabled: raw.enabled,
  for: raw.for
});

export const normalizeUserVars = (raw: UserVars | undefined): UserVars => ({
  email: raw?.email ?? null,
  phone: raw?.phone ?? null
});

export const normalizeCsatSettings = (
  raw: CsatSettingsServer
): ICsatSettings => ({
  enabled: raw.enabled,
  promptText: raw.prompt_text,
  askComment: raw.ask_comment
});
